import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const ileDeFranceMobilites = defineConnector({
  identifier: "ileDeFranceMobilites",
  name: "Île-de-France Mobilités",
  tagLine: "Paris region realtime departures and journey planning",
  keywords: "prim idfm navitia siri metro rer paris transilien",
  logo,
  protocol: "http",
  tags: ["data", "travel"],
  defaultUrlPattern: () => domainToRegex("prim.iledefrance-mobilites.fr"),
  auth: (app) => headerAuth([{ name: "apikey", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Create a PRIM API key",
      items: [
        {
          kind: "markdown",
          content:
            "Sign up for [**PRIM**](https://prim.iledefrance-mobilites.fr/), the Île-de-France Mobilités data platform, then open **My account > My tokens** to generate a key and subscribe it to the APIs you need.",
        },
      ],
    },
    {
      title: "Copy and paste the key into the field below",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          helperText:
            "PRIM serves Navitia journey planning, SIRI Lite realtime departures, and the static GTFS and NeTEx network.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () =>
      "https://prim.iledefrance-mobilites.fr/marketplace/v2/navitia/coverage",
  },
});
